import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {SampleNextArrow} from "../../components/Custom/sliderNext";
import {SamplePrevArrow} from "../../components/Custom/sliderPrev";
import {doc, getDoc} from "firebase/firestore";
import {getDb} from "../../util/Constants";
import {NotificationManager} from "react-notifications";
import Swal from "sweetalert2";

const CognitiveGame = (props) => {
    const history = useHistory();
    const [selected, setSelected] = useState([]);
    const [cognitive, setCognitive] = useState([]);
    const [assessmentInfo, setAssesssmentInfo] = useState({assessmentName: "error", assessmentFor: "error"});

    const selectionLimit = 2;
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: <SampleNextArrow/>,
        prevArrow: <SamplePrevArrow/>,
        responsive: [
            {
                breakpoint: 768, // Adjust this value to your desired breakpoint
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.userData.eventData?.assessmentName && props.userData.eventData?.assessmentFor) {
            setAssesssmentInfo({
                assessmentName: props.userData.eventData?.assessmentName,
                assessmentFor: props.userData.eventData?.assessmentFor
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Event Lost',
                text: 'Kindly Create Event Again',
                confirmButtonText: 'Proceed',
                allowOutsideClick: false
            }).then(result => {
                if (result.isConfirmed) {

                    history.push("/assessment/info");
                }
            })
        }
        if (props.userData.eventData?.selectedLevels?.cognitive) {
            setSelected(props.userData.eventData?.selectedLevels?.cognitive);
        }
        getAbilities().then(result => {
            setCognitive(result);
        })
    }, []);

    const getAbilities = async () => {
        const docRef = doc(getDb(), "Metadata_Games", "cognitive");
        const docSnap = await getDoc(docRef);

        return docSnap.data().data;
    };

    const handleSubmit = () => {
        if (selected.length === selectionLimit) {
            props.setUserData({
                ...props.userData, eventData: {
                    ...props.userData.eventData, selectedLevels: {
                        ...props.userData.eventData.selectedLevels,
                        cognitive: selected,
                    }
                }
            });
            history.push("/assessment/aptitude");
        } else {
            NotificationManager.error("Select 2 games");
        }
    }

    const previous = () => {
        history.goBack();
    }

    return (
        <Container className="ml-0 right-content-container">
            <Row className="">
                <Col>
                    <h1 className="">Your <span
                        className="active-text-color text-capitalize">{assessmentInfo.assessmentName} </span>
                        For <span className="warning-text-color text-capitalize">{assessmentInfo.assessmentFor}</span>
                    </h1>
                    <hr className="mb-0 mt-1 heading-hr mx-2"/>
                </Col>
            </Row>
            <div>
                <h2 className="active-text-color">Cognitive Games</h2>
                <div className="">
                    <div>
                        <span className="fs-14">Select {selectionLimit} Cognitive Games</span>
                        <div className="inner-assessment-content">
                            <Slider {...settings}>
                                {cognitive.map((item, index) => (
                                    <div className="slide-item" key={index}>
                                        <div className="slider-image-wrapper">
                                            <img src={item.image} height={156} alt=""/>
                                        </div>
                                        <Row className="mt-2">
                                            <Col>
                                             <span className="text-sm font-weight-600 text-dark">
                                                {item.name}
                                                </span>
                                            </Col>
                                            <Col className="text-right">
                                                <Button className="add-test-button fs-14 text-dark" size="sm" color=""
                                                        disabled={selected.map(comp => comp.name).includes(item.name) || selected.length >= selectionLimit}
                                                        onClick={() => {
                                                            let tempArray = [...selected];
                                                            tempArray.push({...item, type: "Cognitive"});
                                                            setSelected([...tempArray]);
                                                        }}
                                                > Add Test</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                            </Slider>
                            {selected && selected.length > 0 &&
                                <div className="">
                                    <h4>Your Selection:</h4>
                                    <Row>
                                        {selected.map((_item, index) => (
                                            <Col lg={3} key={index}>
                                                <div className="d-flex games-listing justify-content-between mt-2">
                                                    <span>{_item.name}</span>
                                                    <div className="ml-2">
                                                        <i className="fa fa-times" aria-hidden="true"
                                                           role="button"
                                                           onClick={() => {
                                                               let tempArray = selected;
                                                               tempArray.splice(index, 1);
                                                               setSelected([...tempArray]);
                                                           }}
                                                        />
                                                        {/*<img src={cancelIcon} role="button" alt=""*/}
                                                        {/*     onClick={() => {*/}
                                                        {/*         let tempArray = selected;*/}
                                                        {/*         tempArray.splice(index,1);*/}
                                                        {/*         setSelected([...tempArray]);*/}
                                                        {/*     }}*/}
                                                        {/*/>*/}
                                                    </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            }
                        </div>
                    </div>
                    <Row className="buttons-div">
                        <Col sm={12} xs={12} md={6} lg={8}></Col>
                        <Col sm={12} xs={12} md={3} lg={2}>
                            <Button className="previous-button text-white w-100" onClick={previous}
                                    color="">Previous</Button>
                        </Col>
                        <Col sm={12} xs={12} md={3} lg={2}>
                            <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                    onClick={handleSubmit}
                                    color="">Next</Button>
                        </Col>
                    </Row>
                    {/*<div className="buttons-div">*/}
                    {/*    <div className="d-flex align-items-center" role="button">*/}
                    {/*        <img src={demoButton} alt="" height={17}/>*/}
                    {/*        <span className="text-dark font-weight-600 mx-2">Previous</span>*/}
                    {/*    </div>*/}
                    {/*    <div className="btn-vr"/>*/}
                    {/*    <div className="d-flex align-items-center" role="button" onClick={submitForm}>*/}
                    {/*        <span className="font-weight-600 mx-2 active-text-color">Next</span>*/}
                    {/*        <img src={nextBUtton} alt="" height={17}/>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </Container>
    );
};

export default CognitiveGame;
